export default __webpack_public_path__ + "images/3786b5c9b0f1ba29d2e30b5114897f96.png";